<template>
  <div v-show="info.status === 'edit'">
<!--    <sc-btn text="繁转简" style="margin: 0 10px 10px 0" @click="tran(1)"/>     <sc-btn text="简转繁" @click="tran(2)"/>-->
    <div style="border: 1px solid #ccc">
      <Toolbar
          style="border-bottom: 1px solid #ccc"
          :editor="editorRef"
          :defaultConfig="toolbarConfig"
          mode="default"
      />
      <Editor
          style="height: 500px; overflow-y: hidden;"
          v-model="valueHtml"
          :defaultConfig="editorConfig"
          mode="default"
          @onCreated="handleCreated"
          @onChange="onChange"
      />
    </div>
  </div>
  <div class="w-e-text-container" v-show="info.status === 'show'">
    <div v-html="data[propName]" data-slate-editor/>
  </div>
</template>

<script lang="ts">
import {definedWidgetMeta} from "@/components/business/crud/widgets/widgetManager";

export const meta = definedWidgetMeta({
  size: {edit: 'large', show: 'large'},
});
</script>

<script lang="ts" setup>
import '@wangeditor/editor/dist/css/style.css' // 引入 css
import {Editor, Toolbar} from '@wangeditor/editor-for-vue'
import {defineProps, onBeforeUnmount, onMounted, ref} from "vue";
import {shallowRef} from "vue";
import {DateFieldType} from "@/components/business/crud/interface/FieldType";
import {WidgetInfo} from "@/components/business/crud/widgets/WidgetContainer";
import {ScForm} from "@/models/ScForm";
import {tokenManager} from "@/util/token";
import config from "@/config";
import ScBtn from "@/components/common/widget/ScBtn.vue";
import {Translate} from "@/util/translate/ToolGood.Words.Translate";

const props = defineProps<{
  propName: string;
  widget: DateFieldType;
  info: WidgetInfo;
}>();

const data = ScForm.useFormData();

const editorRef = shallowRef<any>()
const handleCreated = (editor: unknown) => {
  editorRef.value = editor // 记录 editor 实例，重要！
}
// 组件销毁时，也及时销毁编辑器
onBeforeUnmount(() => {
  const editor = editorRef.value
  if (editor == null) return
  editor.destroy()
})

// 内容 HTML
const valueHtml = ref(data.value[props.propName])
const toolbarConfig = {}
const editorConfig = {
  placeholder: '请输入' + props.info.title,
  MENU_CONF: {
    uploadImage: {
      server: config.uploadApiPath,
      fieldName: 'file',
      maxFileSize: 8 * 1024 * 1024,
      maxNumberOfFiles: 10,
      headers: {
        ...tokenManager.get(),
      },
      customInsert(res: any, insertFn: any) {
        if (res.data?.path) {
          insertFn(config.uploadPath + res.data.path, "", "")
        }
      }
    },
    uploadVideo: {
      server: config.uploadApiPath,
      fieldName: 'file',
      maxFileSize: 20 * 1024 * 1024,
      allowedFileTypes: ['video/*'],
      maxNumberOfFiles: 10,
      headers: {
        ...tokenManager.get(),
      },
      customInsert(res: any, insertFn: any) {
        if (res.data?.path) {
          insertFn(config.uploadPath + res.data.path, "")
        }
      }
    }
  }
}

const translate = new Translate();

function tran(type: 1 | 2) {
  if (!editorRef.value) {
    return;
  }
  const origin = editorRef.value.getHtml();
  if (type === 1) {
    editorRef.value.setHtml(translate.ToSimplifiedChinese(origin, 2))
  } else {
    editorRef.value.setHtml(translate.ToTraditionalChinese(origin, 2))
  }
}

function onChange(editor: any) {
  data.value[props.propName] = editor.getHtml();
}


</script>

<style lang="scss" scoped>
.editor-view {
  height: 100%;
  padding-left: 12px;
}

.editor {
  min-height: 400px;
}

.title-box {
  font-size: $font-size;
  padding: 8px 8px;
  border: 1px solid #f0f0f0;
  border-bottom: none;
  display: flex;
  flex-direction: row;
  background: rgb(250, 250, 250);

  .title {
    cursor: pointer;
  }
}

</style>
